import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from 'api/api';
import TokenUtils from 'utils/TokenUtils';
import { addNotification } from './notificationsSlice';

export const getLocations = createAsyncThunk('locations/getLocations', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/locations');

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Не вдалося отримати дані локацій');
  }
});

export const getLocationByTransliteration = createAsyncThunk(
  'locations/getLocationByTransliteration',
  async (locationName, { rejectWithValue }) => {
    try {
      const response = await api.get(`/locations/${locationName}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Не вдалося отримати дані локації');
    }
  }
);

export const createLocation = createAsyncThunk(
  'locations/createLocation',
  async (locationData, { dispatch, rejectWithValue }) => {
    try {
      const token = TokenUtils.getToken();
      const response = await api.post('/locations', locationData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data) {
        dispatch(
          addNotification({
            id: Date.now(),
            title: 'Локація створена успішно',
            type: 'success',
          })
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Не вдалося створити локацію');
    }
  }
);

export const deleteLocations = createAsyncThunk(
  'locations/deleteLocations',
  async (locationIds, { rejectWithValue }) => {
    try {
      const token = TokenUtils.getToken();
      const response = await api.delete('/locations', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { ids: locationIds },
      });

      return response.data?.deletedIds;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Не вдалося видалити локації');
    }
  }
);

const locationsSlice = createSlice({
  name: 'locations',
  initialState: {
    locations: [],
    error: null,
    isLoading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.fulfilled, (state, action) => {
        state.locations = action.payload;
      })
      .addCase(getLocations.rejected, (state, action) => {
        state.error = action.payload || 'Не вдалося отримати дані локацій';
      })
      .addCase(getLocationByTransliteration.fulfilled, (state, action) => {
        const existingIndex = state.locations.findIndex(
          (loc) => loc.transliteration === action.payload.transliteration
        );

        if (existingIndex !== -1) {
          state.locations[existingIndex] = action.payload;
        } else {
          state.locations.push(action.payload);
        }
      })
      .addCase(getLocationByTransliteration.rejected, (state, action) => {
        state.error = action.payload || 'Не вдалося отримати дані локації';
      })
      .addCase(createLocation.fulfilled, (state, action) => {
        state.locations = [action.payload, ...state.locations];
      })
      .addCase(createLocation.rejected, (state, action) => {
        state.error = action.payload || 'Не вдалося створити локацію';
      })
      .addCase(deleteLocations.fulfilled, (state, action) => {
        state.locations = state.locations.filter((loc) => !action.payload.includes(loc.id));
      })
      .addCase(deleteLocations.rejected, (state, action) => {
        state.error = action.payload || 'Не вдалося видалити локації';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected'),
        (state) => {
          state.isLoading = false;
        }
      );
  },
});

export default locationsSlice.reducer;
